import {EventManager} from "shared/core/Events/EventManager";
import {FormulaEditor} from "./Editors/FormulaEditor/FormulaEditor";
import {GetFormulaDialog} from "PDFImporter/Events/GetFormulaDialog";
import * as React from "react";

declare let require:any;

let context=require.context("./", true, /(?<!test)\.tsx?$/);
let library:any={};
for(let key of context.keys())
{
    library[key.substring(0,key.lastIndexOf('.'))]=key;
}

export default function  (libraryName) {
    libraryName='./'+libraryName.substring(18);//removed /InternalShared and adding ./

    if(library[libraryName]==null)
        throw 'Library not found '+libraryName;

    return context(library[libraryName]);


}


EventManager.Subscribe<GetFormulaDialog>('GetFormulaDialog',e=><FormulaEditor DocumentManager={e.DocumentManager} FieldSettings={e.FieldSettings} FormulaName={e.FormulaName}/>)